import React from 'react';
import styles from './CartError.module.scss';
import { Button } from './components/buttons/Button';

export const CartError: React.FC = () => {
  return (
    <div className={styles.hlCartError}>
      <span>We had some trouble updating your selection. Please refresh and try again.</span>
      <Button onClick={() => window.location.reload()} text="Refresh now" />
    </div>
  );
};

export default CartError;
